import React, { useContext } from "react";
import UserPrefsContext from "../../../context/UserPrefs/UserPrefsContext";

import "./RateDetails.scss";

const RateDetails = ({ rates }) => {
  const userPrefs = useContext(UserPrefsContext);
  const selectedRateDetailsId = userPrefs.get('selectedRateDetailsId');

  const selectedRate = rates.find((rate) => rate.id === selectedRateDetailsId);
  const SelectedDetailsComponent =
    (selectedRate || {}).detailsComponent || (() => null);

  const getName = (rate) => {
    if (rate.id === 'EV-SC-1') {
      return 'EV Charge Smart Plan';
    }
    
    return `${rate.title} ${rate.subTitle}`
  }

  return (
    <div className="chart-details-container">
      <div>
        <div className="d-md-flex d-sm-block mb-4">
          {rates.map((rate) => {
            return (
              <button
                className={`btn chartBtn-${
                  rate.id === selectedRateDetailsId ? 'ae' : 'secondary'
                } mr-2`}
                key={rate.id}
                onClick={() =>
                  userPrefs.set({ selectedRateDetailsId: rate.id })
                }
              >
                {getName(rate)}
              </button>
            );
          })}
        </div>
        <div>
          <SelectedDetailsComponent />
        </div>
      </div>
    </div>
  );
};

export default RateDetails;
